module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("A Move Mais")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-yellow"
  }), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "rox"
  }, [_c('div', {
    staticClass: "col-md-6 col-fix margin-t10"
  }, [_c('p', {
    staticClass: "line-height-20 margin-b20"
  }, [_vm._v("A "), _c('b', [_vm._v("Move Mais")]), _vm._v(" é uma empresa de meios de pagamento eletrônico, autorizada pela ARTESP para operar como OSA\n        (Operadora de Serviços de Arrecadação), e pela ANTT para operar como AMAP (Administradora de Meios de Pagamento\n        para Arrecadação de Pedágio). Além dessas atividades, a "), _c('b', [_vm._v("Move Mais")]), _vm._v(" empenha recursos e esforços para desenvolver\n        e entregar novos serviços que venham agregar valor à oferta para o Cliente, Embarcadores, Transportadores, Concessionárias\n        e Credenciados.")]), _vm._v(" "), _c('p', {
    staticClass: "line-height-20 margin-b20"
  }, [_vm._v("Nosso foco é criar e ofertar serviços que promovam conveniência, economia e segurança nas interações entre o veículo,\n        o motorista e o Ambiente por onde tráfega. Para tanto, a "), _c('b', [_vm._v("Move Mais")]), _vm._v(" é responsável pelo cadastro, análise de crédito,\n        ativação, cobrança e conciliação das transações entre clientes e concessionárias e parceiros, seguindo melhores práticas\n        de governança corporativa e segurança da informação.")]), _vm._v(" "), _c('p', {
    staticClass: "line-height-20 margin-b20"
  }, [_vm._v("Suportando os processos está uma moderna e robusta estrutura de tecnologia da informação, com sistemas e infraestrutura\n        em constante atualização, sempre alinhada às áreas de negócio, atendimento ao cliente e back-office.")]), _vm._v(" "), _c('p', {
    staticClass: "line-height-20 margin-b20"
  }, [_vm._v("Completando o tripé de sustentação, a "), _c('b', [_vm._v("Move Mais")]), _vm._v(" conta com equipe comprometida, treinada e motivada, liderada por\n        executivos com significativas experiências em empresas brasileiras e multinacionais.")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Nossa razão de existir é você ter mais tempo para o que te move.")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-fix"
  }, [_c('img', {
    staticClass: "img-about-move-mais",
    attrs: {
      "src": require("../../assets/img/img-about-move-mais-2026.svg"),
      "alt": ""
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-eb309142!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/move-mais.vue
// module id = 2222
// module chunks = 1